import { Button, ButtonSizes, ButtonTypes } from '@leegality/leegality-react-component-library';
import PropTypes from 'prop-types';
import React from 'react';

const FeedbackSubmitButton = ({
  label, disabled, loading, onClick,
}) => (
  <Button
    type={ButtonTypes.PRIMARY}
    size={ButtonSizes.LARGE}
    label={label}
    className="feedback-brand-button w-full"
    disabled={disabled || loading}
    loading={loading}
    onClick={onClick}
  />
);

FeedbackSubmitButton.propTypes = {
  label: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};

FeedbackSubmitButton.defaultProps = {
  disabled: false,
  loading: false,
};

export default FeedbackSubmitButton;
